import { fold } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/function';
import { Dispatch } from 'redux';
import Area from '../../../domain/entities/Area';
import MerchantCategory from '../../../domain/entities/MerchantCategory';
import { newExploresApi } from '../../../infrastructure/api/backend/api';
import ExploreAreaRepository from '../../../infrastructure/repositories/ExploreAreaRepository';
import MerchantCategoryRepository from '../../../infrastructure/repositories/MerchantCategoryRepository';
import { VAreasSuggestionResponse } from '../../../infrastructure/repositories/validators';

import { SEARCH_AREAS, SEARCH_CATEGORIES } from '../../reducers/explore';

const searchAreas = (query: string, merchantCategoryId: number) => async (
  dispatch: Dispatch,
) => {
  if (query) {
    const api = newExploresApi();
    const res = await api.exploreAreasSuggestion(merchantCategoryId, query);
    pipe(
      VAreasSuggestionResponse.decode(res.data),
      fold(
        e => {
          throw e;
        },
        data => {
          dispatch({
            type: SEARCH_AREAS,
            payload: {
              exAreas: data.areas,
              exStations: data.stations,
            },
          });
        },
      ),
    );
  } else {
    dispatch({
      type: SEARCH_AREAS,
      payload: {
        exAreas: await ExploreAreaRepository.Search({
          areaIds: Area.PopularIds,
          merchantCategoryId,
        }),
        exStations: [],
      },
    });
  }
};

const searchCategories = () => async (dispatch: Dispatch) => {
  const categories: MerchantCategory[] = await MerchantCategoryRepository.Search().catch(
    () => [],
  );

  dispatch({ type: SEARCH_CATEGORIES, payload: { categories } });
};

export default {
  searchAreas,
  searchCategories,
};
